import { MAX_WIDTH_RATIO_AI_CHAT_PANEL, MIN_WIDTH_AI_CHAT_PANEL } from '@/lib/constants';

export const maxWidth = (windowWidth) => Math.round(windowWidth * MAX_WIDTH_RATIO_AI_CHAT_PANEL);

export const constrainWidth = (width, windowWidth) => {
  if (width < MIN_WIDTH_AI_CHAT_PANEL) {
    return MIN_WIDTH_AI_CHAT_PANEL;
  }
  return Math.min(width, maxWidth(windowWidth));
};

export const sidePeekOffset = (aiChatWidth) => ({ right: `${aiChatWidth}px` });

export const layoutWidth = ({ open, smAndDown, width, windowWidth }) => {
  if (!open || smAndDown) {
    return 0;
  }
  return constrainWidth(width, windowWidth);
};
